import { render, staticRenderFns } from "./RegistrationConfirmation.vue?vue&type=template&id=eada10de"
import script from "./RegistrationConfirmation.vue?vue&type=script&lang=js"
export * from "./RegistrationConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports